import { useLazyQuery } from "@apollo/client/react"; import { FormControl, Grid, InputAdornment, InputLabel, MenuItem, Select, TextField } from '@mui/material';
import React, { useEffect, useRef, useState } from 'react';
import { DateInput } from '../../../components/dateInput/DateInput';
import { CustomButton } from '../../../components/customButton/CustomButton';
import SearchIcon from '@mui/icons-material/Search';

import { GET_DELEGACIONES_BY_USUARIO } from '../../../data/graphQL/queries/PacienteProbable/getAllDelegacionesByUsuario';
import { adaptDelegacionArray } from '../../../adapters/delegacionAdapter';
import { GET_USUARIO_DELEGACION_ORIGEN } from '../../../data/graphQL/queries/usuarios/getUsuarioDelegacionOrigen';
import { GET_IMPRIMIR_MINUTAS, adaptImprimirMinutasArray } from '../../../data/graphQL/queries/ImprimirMinuta/getImprimirMinutas';
import moment from 'moment';
import toast from 'react-hot-toast';
import { CompareDates } from '../../../utils/helpers';

export const ImprimirMinutaGrillaFilters = ({
  delegaciones,
  filters,
  printLoading,
  setImprimirMinutasGrilla,
  setImprimirMinutasGrillaLoading,
  setDelegaciones,
  handleChangeFilters,
  refetchGrilla,
  setRefetchGrilla
}) => {
  const storageId = sessionStorage.getItem('idUsuario');
  const [delegacionOrigen, setDelegacionOrigen] = useState(0);
  const [datosOriginal, setDatosOriginal] = useState([]);
  const [textFilter, setTextFilter] = useState(null);
  const txtFiltro = useRef(null);

  useEffect(() => {
    if (!delegacionesLoading)
      getDelegaciones({ variables: { idUsuario: JSON.parse(storageId, 10) } });
  }, []);

  const [getDelegaciones, { data: delegacionesData, loading: delegacionesLoading }] = useLazyQuery(GET_DELEGACIONES_BY_USUARIO, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (!delegacionesData) return;
    setDelegaciones(adaptDelegacionArray(delegacionesData));
  }, [delegacionesData]);

  useEffect(() => {
    if (delegaciones != null && !delegacionOrigenLoading)
      getDelegacionOrigen({ variables: { idUsuario: JSON.parse(storageId, 10) } });
  }, [delegaciones]);

  const [getDelegacionOrigen, { data: delegacionOrigenData, loading: delegacionOrigenLoading }] = useLazyQuery(GET_USUARIO_DELEGACION_ORIGEN, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (!delegacionOrigenData) return;
    if (delegacionOrigenData.usuarioFull.success) {
      const deleg = parseInt(delegacionOrigenData.usuarioFull.valorEsperado.delegacionOrigen, 10);
      setDelegacionOrigen(deleg);
      handleChangeFilters('idDelegacion', localStorage.getItem('imprimirMinutaGrillaFilters') != null && filters.idDelegacion > 0 ? filters.idDelegacion : deleg);
    }
  }, [delegacionOrigenData]);

  useEffect(() => {
    if (refetchGrilla && !imprimirMinutasGrillaLoading)
      handleSearch();
  }, [refetchGrilla]);

  const [getImprimirMinutas, { data: dataImprimirMinuta, loading: imprimirMinutasGrillaLoading }] = useLazyQuery(GET_IMPRIMIR_MINUTAS, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (!dataImprimirMinuta) return;
    setImprimirMinutasGrillaLoading(false);
    const regs = adaptImprimirMinutasArray(dataImprimirMinuta.imprimirMinutasGrilla);
    setDatosOriginal(regs);
    setImprimirMinutasGrilla(regs);
    setRefetchGrilla(false);
  }, [dataImprimirMinuta]);


  const validateFilters = () => {
    if (filters.fechaDesde == "" || filters.fechaHasta == "") {
      toast.error("La Fecha desde y la Fecha hasta son obligatorias.");
      return false;
    }

    if (CompareDates(filters.fechaDesde, filters.fechaHasta) === 1) {
      toast.error("La Fecha desde no puede ser posterior a la Fecha hasta.");
      return false;
    }

    return true;
  };

  const handleSearch = () => {
    if (!imprimirMinutasGrillaLoading && validateFilters()) {
      setTextFilter('');
      setImprimirMinutasGrilla([]);
      setImprimirMinutasGrillaLoading(true);
      getImprimirMinutas({ variables: { filter: filters } });
    }
  };

  const handleTextFilter = () => {
    const inputBuscar = textFilter?.toString().toUpperCase();

    if (inputBuscar?.length >= 2) {
      setImprimirMinutasGrilla(datosOriginal?.filter((datoOriginal) => {
        const minutaBuscar = datoOriginal.idMinuta.toString();
        const pacienteBuscar = datoOriginal.paciente.toString();
        const clienteBuscar = datoOriginal.cliente.toUpperCase();
        const nombreClienteBuscar = datoOriginal.nombreCliente.toUpperCase();
        const programaBuscar = datoOriginal.modulo.toUpperCase();
        const facturaBuscar = datoOriginal.numeroFactura.toString();

        return (
          minutaBuscar.includes(inputBuscar) ||
          pacienteBuscar.includes(inputBuscar) ||
          clienteBuscar.includes(inputBuscar) ||
          nombreClienteBuscar.includes(inputBuscar) ||
          programaBuscar.includes(inputBuscar) ||
          facturaBuscar.includes(inputBuscar));

      }));
    } else {
      setImprimirMinutasGrilla(datosOriginal);
    }
  };

  const handleChangeFecha = (name, value) => {
    handleChangeFilters(name, moment(value).isValid() ? moment(value).format("YYYY-MM-DD") : '');
  };

  return (
    <>
      <Grid container spacing={2}>
        <Grid size={{ md: 1.8 }}>
          <DateInput
            label="Fecha Desde"
            value={filters?.fechaDesde}
            onChange={(value) => handleChangeFecha("fechaDesde", value)}
            name="fechaDesde" />

        </Grid>
        <Grid size={{ md: 1.8 }}>
          <DateInput
            label="Fecha Hasta"
            value={filters?.fechaHasta}
            onChange={(value) => handleChangeFecha("fechaHasta", value)}
            name="fechaHasta" />

        </Grid>
        <Grid size={{ md: 2.5 }}>
          <FormControl sx={{ backgroundColor: 'white', width: '100%' }} size="small">
            <InputLabel id="select-delegacion">Delegación</InputLabel>
            <Select
              labelId="select-delegacion"
              options={delegaciones}
              label='Delegación'
              onChange={(e) => {
                handleChangeFilters('idDelegacion', e.target.value);
              }}
              value={filters?.idDelegacion}
              name='idDelegacion'>

              {delegaciones && delegaciones.map((delegacion) => {
                return delegacion.id > 0 && <MenuItem key={delegacion.id} value={delegacion.id}> {delegacion.displayName} </MenuItem>;
              })}
            </Select>
          </FormControl>
        </Grid>
        <Grid size={{ md: 3 }}>
          <TextField
            label="Filtrar"
            name="txtFiltro"
            size="small"
            type="text"
            variant="outlined"
            value={textFilter ?? ''}
            onChange={(e) => setTextFilter(e.target.value)}
            onKeyUp={handleTextFilter}
            sx={{ backgroundColor: 'white', width: '100%' }}
            InputProps={{
              endAdornment:
                <InputAdornment position="end">
                  <SearchIcon
                    onClick={handleTextFilter}
                    sx={{ cursor: 'pointer' }} />

                </InputAdornment>

            }} />

        </Grid>
        <Grid size={{ md: 2.9 }} display="flex" justifyContent="flex-end" alignItems="center">
          <CustomButton
            className='margin-right'
            disabled={printLoading}
            isLoading={imprimirMinutasGrillaLoading}
            onClick={handleSearch}
            size='small'
            variant='contained'>
            Buscar
          </CustomButton>
        </Grid>
      </Grid>
    </>);

};